import React from "react";
import { Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import { getAppColor } from "@icarius-app/selectors";

const NumberItem = ({ name, value, onClick, selected }) => {
    const color = useSelector(getAppColor);

    return (
        <div
            onClick={onClick}
            style={{
                cursor: "pointer",
                background: "var(--secondaryBackgroundColor)",
                border: selected ? `2px solid ${color}` : "1px solid var(--divider)",
                borderRadius: 35,
                padding: "5px 15px",
                paddingRight: 5,
                display: "flex",
                alignItems: "center",
                gap: 20,
            }}
        >
            <Typography className="whiteText" style={{ fontSize: 15 }}>
                {name}
            </Typography>
            <Typography
                style={{
                    width: 35,
                    height: 35,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: color,
                    borderRadius: "100%",
                    color: "white",
                    fontSize: 14,
                }}
            >
                {value > 99 ? "+99" : value}
            </Typography>
        </div>
    );
};

export default NumberItem;
